export default function FirebaseSyncPlugin() {
	return store => {

		// connect to VUEX
		store.subscribe(mutation => {

			// ONLY SEND UPDATES IF YOU ARE THE OPERATOR
			if (store.state.user.isController) {
				switch (mutation.type) {

					case 'SET_PAGE':
						store.state.sessionRef.update({
							pageName: mutation.payload
						});
						break;

					case 'SET_HINT':
						if (mutation.payload == 'controller') {
							store.state.sessionRef.update({
								showControllerPage: true
							});
						} else {
							store.state.sessionRef.update({
								showControllerPage: false
							});
						}
						break;

					case 'SET_SIDE':
						store.state.sessionRef.update({
							side: mutation.payload
						});
						break;

					case 'SET_DIFFICULTY':
						store.state.sessionRef.update({
							difficulty: mutation.payload
						});
						break;

					case 'SET_VISION':
						store.state.sessionRef.update({
							visionText: mutation.payload
						});
						break;

					case 'SET_MOTIVATION':
						store.state.sessionRef.update({
							motivationText: mutation.payload
						});
						break;

					case 'SET_IMPACT':
						store.state.sessionRef.update({
							impactText: mutation.payload
						});
						break;

					case 'SET_METHOD':
						store.state.sessionRef.update({
							methodText: mutation.payload
						});
						break;

					case 'SET_TARGET':
						store.state.sessionRef.update({
							targetText: mutation.payload
						});
						break;

					case 'SET_OBJECTIVE':
						store.state.sessionRef.update({
							objectiveText: mutation.payload
						});
						break;

					case 'SET_ARCHETYPE':
						store.state.sessionRef.update({
							selectedArchetype: mutation.payload
						});
						break;

					case 'SET_ARCHETYPE_OTHER':
						store.state.sessionRef.update({
							archetypeOtherText: mutation.payload
						});
						break;

					case 'SET_ROLE':
						store.state.sessionRef.update({
							selectedRole: mutation.payload
						});
						break;

					case 'SET_ROLE_OTHER':
						store.state.sessionRef.update({
							roleOtherText: mutation.payload
						});
						break;

					case 'SET_ROLE_TAB':
						store.state.sessionRef.update({
							roleActiveTab: mutation.payload
						});
						break;

					case 'SET_STRATEGY_TAB':
						store.state.sessionRef.update({
							strategyActiveTab: mutation.payload
						});
						break;

					case 'SET_CONFIRM_TAB':
						store.state.sessionRef.update({
							confirmActiveTab: mutation.payload
						});
						break;

					case 'SET_FEEDBACK_TAB':
						store.state.sessionRef.update({
							feedbackActiveTab: mutation.payload
						});
						break;

					case 'SET_FEEDBACK':
						store.state.sessionRef.update({
							feedback: store.state.feedback
						});
						break;
				}
			}


			// Only send time updates if you are the operator
			if (store.state.user.isAdmin) {

				// Check mutation type and make sure the sessionRef is available
				if (mutation.type == 'SET_COUNTDOWN' && store.state.sessionRef) {
					store.state.sessionRef.update({
						countdown: mutation.payload
					});
				}

				// also send page redirects if user isAdmin
				else if (mutation.type == 'SET_PAGE') {
					store.state.sessionRef.update({
						pageName: mutation.payload
					});
				}
			}
		})
	}
}